<template>
	<div class="container">
		<myHeader></myHeader>
		<div class="main" v-loading="loading" element-loading-text="加载中 ...">
			<div class="banner">
				<img src="../assets/banner/policy_banner.jpg" />
			</div>
			<div class="policy-list">
				<el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
					<el-tab-pane v-for="(items,index) in policyType.data" :key="index" :label="items.name"
						:name="items.value">
						<div class="item" v-for="(item, index) in dataList" :key="index"
							@click="toPolicyDetail(item.markPoliciesId)">
							<div class="title">
								{{ item.markPoliciesTitle }}
							</div>
							<div class="info">
								<div class="tags">
									<span v-if="item.markPoliciesLevel == 1">国家级</span>
									<span v-if="item.markPoliciesLevel == 2">省级</span>
									<span v-if="item.markPoliciesLevel == 3">市级</span>
									<span v-if="item.markPoliciesLevel == 4">区县级</span>
									|
									<span v-if="item.markPoliciesType == 1">财税减免</span>
									<span v-if="item.markPoliciesType == 2">奖补帮扶</span>
									<span v-if="item.markPoliciesType == 3">优化服务</span>
									<span v-if="item.markPoliciesType == 4">金融信贷</span>
									<span v-if="item.markPoliciesType == 5">要素保障</span>
								</div>
								<div class="date">
									<!-- <img class="icon" src="../assets/images/time.png"><span>{{ item.createTime }}</span> -->
								</div>
							</div>
						</div>
						<div class="more-list" v-if="isMore" @click="loadMore()">查看更多</div>
						<div class="more-list" v-if="noMore">没有更多</div>
					</el-tab-pane>
				</el-tabs>

			</div>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import {
		useRouter
	} from 'vue-router'
	import {
		ref,
		reactive,
		defineComponent
	} from 'vue'
	import {
		ElMessage
	} from 'element-plus'
	import {
		getPolicyList
	} from '@/axios/api'
	import myHeader from '@/components/layouts/myHeader'
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	export default defineComponent({
		components: {
			myHeader,
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {
			const router = useRouter();
			const baseUrl = 'https://ysdtapi.cdssjj.changde.gov.cn/cdMapApi';
			const loading = ref(true);
			const dataList = ref('');
			const step = ref(10); //每次增加数量
			const count = ref(10); //初始化当前显示数量
			const isMore = ref(true);
			const noMore = ref(false);
			const activeName = ref(0);
			const markPolicyType = ref(0);
			const markPolicyLevel = ref(0);
			// 分类
			const policyType = reactive({
				data: [{
					id: 1,
					name: '全部',
					value: 0
				}, {
					id: 2,
					name: '财税减免',
					value: 1
				}, {
					id: 3,
					name: '奖补帮扶',
					value: 2
				}, {
					id: 4,
					name: '优化服务',
					value: 3
				}, {
					id: 5,
					name: '金融信贷',
					value: 4
				}, {
					id: 6,
					name: '要素保障',
					value: 5
				}]
			});

			(function getListData() {
				getData();
				// 当前显示数量存入session
				sessionStorage.setItem('count', count.value);
			})();

			// 点击加载更多
			function loadMore() {
				// 当前显示数量
				count.value = parseInt(sessionStorage['count']) + step.value;
				// 当前显示数量存入session
				sessionStorage.setItem('count', count.value);
				getData();
			}
			
			// 按类型切换数据
			function handleClick(event) {
				markPolicyType.value = event.index
				getData();
			}

			// 获取数据
			function getData() {
				getPolicyList('/cdMapApi/api/policy/list', {
					markPoliciesType: markPolicyType.value,
					markPoliciesLevel: markPolicyLevel.value
				}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						loading.value = false;
						// 当前渲染数据列表
						dataList.value = data.slice(0, count.value)
						if (count.value >= data.length) {
							isMore.value = false
							noMore.value = true
						}

					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				})
			}
			
			// 跳转政策详情
			function toPolicyDetail(policyId) {
				router.push({
					name: 'policyDetail',
					query: {
						policyId: policyId
					}
				})
			}

			return {
				baseUrl,
				markPolicyType,
				markPolicyLevel,
				handleClick,
				activeName,
				policyType,
				loading,
				isMore,
				noMore,
				loadMore,
				dataList,
				toPolicyDetail
			}
		}
	})
</script>

<style lang="scss">
	.container {
		height: auto;
		min-height: 100vh;
		margin: 0;
		padding: 0;

		.main {

			.banner {
				width: 100%;
				margin-bottom: 10px;
				overflow: hidden;

				img {
					width: 100%;
				}
			}

			.policy-list {
				padding: 0px 10px;
				
				.el-tabs {
					padding: 0px;
				}
				
				.el-tabs__item {
					padding: 0px 10px;
				}

				.item {
					background: url(../assets/images/more.png);
					background-repeat: no-repeat;
					background-size: 30px 30px;
					background-position: center right;
					margin: 10px;
					padding-right: 30px;
					padding-bottom: 10px;
					border-bottom: #e9e9e9 1px dashed;

					.title {
						font-size: 16px;
						line-height: 25px;
						text-align: left;
						color: #333;
						word-wrap: break-word;
						padding-bottom: 5px;
					}

					.info {
						display: flex;
						justify-content: space-between;
						align-items: center;

						.tags {
							display: flex;
							align-items: center;
							color: #999;

							span:first-child {
								padding-right: 5px;
							}

							span:last-child {
								padding-left: 5px;
							}

						}

						.date {
							display: flex;
							align-items: center;
							color: #999;
							padding: 0px 5px;

							.icon {
								width: 18px;
								padding-right: 5px;
							}
						}
					}
				}

				.more-list {
					line-height: 50px;
					text-align: center;
				}
			}
		}
	}
</style>